import {
    PRINTING_PRESS_PARTICULARS,
    PRINTING_PRESS_OPERATING_ADDRESS,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/PPLApplication';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatPPLApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    for (const key in licenceDetails.supportingDocuments) {
        if (licenceDetails.supportingDocuments.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.supportingDocuments[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'printing-press-licence',
        formID: 'printing-press-licence',
        hasError: true,
        title: application?.startsWith('IMDA-IRIS-Work-LICApplication') ? 'Application Details' : 'Licence Details',
        values: {
            [`${PRINTING_PRESS_PARTICULARS}-operating-address-is-the-same-as-acra-registered-address`]:
                licenceDetails?.printingPressParticulars?.operatingAddressIsTheSameAsAcraRegisteredAddress ?? '-',

            [`${PRINTING_PRESS_OPERATING_ADDRESS}-name-of-printing-press`]:
                licenceDetails?.printingPressParticulars?.nameOfPrintingPress ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-postal-code`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.postalCode ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-block-house-no`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.blockNo ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-street-name`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.streetName ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-floor-level`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.floor ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-unit`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.unit ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-building-name`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.buildingName ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-telephone-number`]:
                licenceDetails?.printingPressParticularsOfficeContact?.telephoneNumber ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-mobile-number`]:
                licenceDetails?.printingPressParticularsOfficeContact?.mobileNumber ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-number-of-machines`]: licenceDetails?.printingMachineParticulars?.noOfMachines ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application?.startsWith('IMDA-IRIS-Work-LICApplication') ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-printing-press-licence',
            formID: 'renew-printing-press-licence',
            hasError: true,
            title: application?.startsWith('IMDA-IRIS-Work-LICApplication') ? 'Application Details' : 'Station and Equipment Details',
            values: {
                // [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                // [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                // [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                // [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                // [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                // [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                // [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                // [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                // [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''

                [`${PRINTING_PRESS_PARTICULARS}-operating-address-is-the-same-as-acra-registered-address`]:
                    licenceDetails?.printingPressParticulars?.operatingAddressIsTheSameAsAcraRegisteredAddress ?? '-',

                [`${PRINTING_PRESS_OPERATING_ADDRESS}-name-of-printing-press`]:
                    licenceDetails?.printingPressParticulars?.nameOfPrintingPress ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-postal-code`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.postalCode ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-block-house-no`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.blockNo ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-street-name`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.streetName ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-floor-level`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.floor ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-unit`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.unit ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-building-name`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.buildingName ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-telephone-number`]:
                    licenceDetails?.printingPressParticularsOfficeContact?.telephoneNumber ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-mobile-number`]:
                    licenceDetails?.printingPressParticularsOfficeContact?.mobileNumber ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-number-of-machines`]: licenceDetails?.printingMachineParticulars?.noOfMachines ?? '-',

                [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-printing-press-licence',
            formID: 'amend-printing-press-licence',
            hasError: true,
            title: application?.startsWith('IMDA-IRIS-Work-LICApplication') ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${PRINTING_PRESS_PARTICULARS}-operating-address-is-the-same-as-acra-registered-address`]:
                    licenceDetails?.printingPressParticulars?.operatingAddressIsTheSameAsAcraRegisteredAddress ?? '-',

                [`${PRINTING_PRESS_OPERATING_ADDRESS}-name-of-printing-press`]:
                    licenceDetails?.printingPressParticulars?.nameOfPrintingPress ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-postal-code`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.postalCode ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-block-house-no`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.blockNo ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-street-name`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.streetName ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-floor-level`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.floor ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-unit`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.unit ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-building-name`]:
                    licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.buildingName ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-telephone-number`]:
                    licenceDetails?.printingPressParticularsOfficeContact?.telephoneNumber ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-mobile-number`]:
                    licenceDetails?.printingPressParticularsOfficeContact?.mobileNumber ?? '-',
                [`${PRINTING_PRESS_OPERATING_ADDRESS}-number-of-machines`]: licenceDetails?.printingMachineParticulars?.noOfMachines ?? '-',

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }

    return licence;
};

const pplPayloadApplication = {
    formatPPLApplication
};

export default pplPayloadApplication;
